export default {
  SALES_INVOICES_LIST: "Invoice list",
  ADD_SALES_INVOICE: "Invoice",
  ADD_SALES_INVOICE_ITEM: "Line",
  SALES_INVOICE_ADDED: "Invoice added",
  OWNER: "Owner",
  EDIT_SALES_INVOICE: "Change an invoice",
  SALES_INVOICE_UPDATED: "Update",
  BILLING_ADDRESS: "Billing address",
  EXPIRATION_TIME: "Deadline",
  ITEM_TYPE: "type",
  SELECT_PRODUCTS: "Choose a product",
  SELECT_SUBSCRIPTIONS: "Choose a registration",
  SELECT_PACKAGES: "Choose a package",
  DELETE_SALES_INVOICE_ITEM: "Delete the line",
  UPDATE_SALES_INVOICE_ITEM: "Edit the line",
  SALES_INVOICE_ITEM_DELETED: "Deleted line",
  SALES_INVOICE_ITEM_ADDED: "Line added",
  SALES_INVOICE_ITEM_EDITED: "Modified line",
  SEND: "Send",
  CANCEL: "Cancel",
  REFUND: "Repay",
  ADD_PAYMENT: "Add a payment",
  SALES_INVOICE_SENT: "Invoice sent",
  SELECT_USERS: "Choose the user",
  SELECT_CUSTOMERS: "Choose",
  SELECT_ORGANIZATIONS: "Choose",
  SELECT_SUPPLIERS: "Choose the supplier",
  DELETE_THIS_SALES_INVOICE: "Delete this invoice?",
  SALES_INVOICE_DELETED: "Invoice deleted",
  CANCEL_SALES_INVOICE_QUESTION: "Cancel the invoice?",
  SALES_INVOICE_CANCELED: "Invoice canceled",
  RECIPIENT: "Recipient",
  ISSUER: "Issuer",
  VALIDATE: "To validate",
  SALES_INVOICE_VALIDATED: "Validated invoice",
  VIEW_ORDER: "See the order",
  VIEW_SALES_INVOICE: "Purchase invoice",

  CREATED_AT: "Created at",
};
